import type { IconProps } from './types';
import './icons.css';

export default function Settings({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 17}
      viewBox="0 0 16 17"
      className={`icon icon-settings ${className || ''}`}
      fill="none"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.933 3.833c-.84 0-1.533.69-1.533 1.556 0 .865.693 1.555 1.533 1.555s1.534-.69 1.534-1.555c0-.866-.693-1.556-1.534-1.556Zm-2.79.89a2.872 2.872 0 0 1 2.79-2.223c1.36 0 2.492.952 2.79 2.222h1.61a.667.667 0 1 1 0 1.334h-1.61a2.872 2.872 0 0 1-2.79 2.222 2.872 2.872 0 0 1-2.79-2.222H.668a.667.667 0 0 1 0-1.334h7.477Zm-5.866 6.221a2.872 2.872 0 0 1 2.79-2.222c1.36 0 2.491.952 2.79 2.222h7.476a.667.667 0 0 1 0 1.334H7.856a2.872 2.872 0 0 1-2.79 2.222 2.872 2.872 0 0 1-2.79-2.222H.667a.667.667 0 0 1 0-1.334h1.61Zm2.79-.888c-.84 0-1.534.69-1.534 1.555 0 .866.693 1.556 1.534 1.556.84 0 1.533-.69 1.533-1.556 0-.865-.693-1.555-1.533-1.555Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
